/* KLOKI Moon — dostupnost podle země: mapa světa + vyhledávač.
   Data od zadavatele 12. 8. 2026 (Globalni_dostupnost_hodinek_4G_VoLTE).
   POZOR: Kolumbie byla v podkladech ve dvou skupinách zároveň („jen data“
   i „nefunguje“). Vedeme ji jako „jen data“ — nutno potvrdit.

   Geometrie: world-atlas 110m (Natural Earth, public domain) přes d3-geo.
   Země se v mapě párují na ISO 3166-1 numeric. Ministáty (Vatikán, Monako,
   San Marino, Andorra, Lichtenštejnsko, Malta, Singapur, Bahrajn, Hongkong,
   Macao, Maledivy, Seychely, Samoa, Nauru, Palau) ve 110m nejsou nebo jsou
   subpixelové — v mapě je nenajdete, ve vyhledávači ano. Vyhledávač je proto
   závazný zdroj, mapa je přehled. */
(function () {
  /* name, ISO numeric */
  var FULL = [['Albánie',8],['Andorra',20],['Rakousko',40],['Ázerbájdžán',31],['Belgie',56],['Bulharsko',100],['Chorvatsko',191],['Kypr',196],['Česko',203],['Dánsko',208],['Estonsko',233],['Finsko',246],['Francie',250],['Gruzie',268],['Německo',276],['Řecko',300],['Maďarsko',348],['Island',352],['Irsko',372],['Itálie',380],['Lotyšsko',428],['Lichtenštejnsko',438],['Litva',440],['Lucembursko',442],['Nizozemsko',528],['Norsko',578],['Polsko',616],['Portugalsko',620],['Rumunsko',642],['San Marino',674],['Slovensko',703],['Slovinsko',705],['Španělsko',724],['Švédsko',752],['Švýcarsko',756],['Turecko',792],['Velká Británie',826],['Vatikán',336],['Bahrajn',48],['Čína',156],['Hongkong',344],['Indie',356],['Izrael',376],['Japonsko',392],['Jižní Korea',410],['Kuvajt',414],['Macao',446],['Malajsie',458],['Filipíny',608],['Katar',634],['Singapur',702],['Srí Lanka',144],['Tchaj-wan',158],['Thajsko',764],['Vietnam',704],['Etiopie',231],['Ghana',288],['Keňa',404],['Mauricius',480],['Jihoafrická republika',710],['Argentina',32],['Brazílie',76],['Kostarika',188],['Guatemala',320],['Mexiko',484],['Peru',604],['Austrálie',36],['Nový Zéland',554],['Samoa',882]];

  var DATA = [['Arménie',51],['Bělorusko',112],['Bosna a Hercegovina',70],['Kosovo',383],['Malta',470],['Moldavsko',498],['Monako',492],['Černá Hora',499],['Severní Makedonie',807],['Rusko',643],['Srbsko',688],['Ukrajina',804],['Afghánistán',4],['Bangladéš',50],['Bhútán',64],['Brunej',96],['Kambodža',116],['Indonésie',360],['Irák',368],['Jordánsko',400],['Kazachstán',398],['Kyrgyzstán',417],['Libanon',422],['Maledivy',462],['Mongolsko',496],['Omán',512],['Pákistán',586],['Saúdská Arábie',682],['Tádžikistán',762],['Spojené arabské emiráty',784],['Uzbekistán',860],['Alžírsko',12],['Angola',24],['Botswana',72],['Kapverdy',132],['Čad',148],['Republika Kongo',178],['Demokratická republika Kongo',180],['Egypt',818],['Eswatini',748],['Gabon',266],['Gambie',270],['Pobřeží slonoviny',384],['Lesotho',426],['Libérie',430],['Madagaskar',450],['Malawi',454],['Mali',466],['Maroko',504],['Mosambik',508],['Namibie',516],['Nigérie',566],['Rwanda',646],['Senegal',686],['Seychely',690],['Tanzanie',834],['Tunisko',788],['Uganda',800],['Zambie',894],['Zimbabwe',716],['Chile',152],['Kolumbie',170],['Dominikánská republika',214],['Panama',591],['Surinam',740],['Uruguay',858],['Fidži',242],['Nauru',520],['Papua-Nová Guinea',598],['Tonga',776],['Vanuatu',548]];

  var NONE = [['USA',840],['Kanada',124],['Ekvádor',218],['Honduras',340],['Nikaragua',558],['Bolívie',68],['Salvador',222],['Paraguay',600],['Trinidad a Tobago',780],['Palau',585]];

  /* Lidé hledají jinak, než se země jmenuje v seznamu. */
  var ALIAS = {
    'USA': 'spojene staty americke amerika united states',
    'Velká Británie': 'anglie uk britanie skotsko wales londyn',
    'Spojené arabské emiráty': 'sae emiraty dubaj abu dhabi',
    'Nizozemsko': 'holandsko', 'Tchaj-wan': 'taiwan', 'Jižní Korea': 'korea soul',
    'Česko': 'ceska republika cr', 'Jihoafrická republika': 'jar',
    'Černá Hora': 'montenegro', 'Severní Makedonie': 'makedonie',
    'Bosna a Hercegovina': 'bosna', 'Velká Británie ': ''
  };

  /* ZÁPLATA THEME: texty přicházejí ze sekce (data-kl-i18n), aby nebyly natvrdo
     česky na pěti cizích trzích. Když atribut chybí, použijí se české výchozí
     hodnoty z předlohy — fail-open. */
  var HOST = document.getElementById('kl-zone-map');
  var T = {};
  try { T = JSON.parse((HOST && HOST.getAttribute('data-kl-i18n')) || '{}'); } catch (e) { T = {}; }
  function tr(k, vychozi) { return (T && T[k]) ? T[k] : vychozi; }

  var TIERS = {
    full: { label: tr('full_label', '4G data + volání'), note: tr('full_note', 'Funguje všechno, na co jste zvyklí z domova.'), calls: true, fill: '#35B695' },
    data: { label: tr('data_label', 'Jen 4G data, bez volání'), note: tr('data_note', 'Poloha, zprávy i fotky fungují. Volání v téhle zemi ne.'), calls: false, fill: '#FDD500' },
    none: { label: tr('none_label', 'Bez záruky spolehlivého fungování'), note: tr('none_note', 'V této zemi nemůžeme zaručit dostupnost mobilní sítě a správné fungování hodinek.'), calls: false, fill: '#E0808A' }
  };
  var NEUTRAL = '#E2E8F0';

  function norm(s) {
    return String(s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  /* ZÁPLATA THEME: názvy zemí se nepřekládají ručně (150 zemí x 6 jazyků).
     Data nesou ISO 3166-1 numeric, takže stačí převod na alpha-2 a zbytek
     udělá prohlížeč přes Intl.DisplayNames. České názvy zůstávají ve
     vyhledávacím klíči jako alias, aby zákazník našel zemi i pod původním
     jménem. Bez Intl.DisplayNames (staré prohlížeče) zůstanou české — fail-open. */
  var A2 = {4:'AF',8:'AL',12:'DZ',20:'AD',24:'AO',31:'AZ',32:'AR',36:'AU',40:'AT',48:'BH',50:'BD',51:'AM',56:'BE',64:'BT',68:'BO',70:'BA',72:'BW',76:'BR',96:'BN',100:'BG',112:'BY',116:'KH',124:'CA',132:'CV',144:'LK',148:'TD',152:'CL',156:'CN',158:'TW',170:'CO',178:'CG',180:'CD',188:'CR',191:'HR',196:'CY',203:'CZ',208:'DK',214:'DO',218:'EC',222:'SV',231:'ET',233:'EE',242:'FJ',246:'FI',250:'FR',266:'GA',268:'GE',270:'GM',276:'DE',288:'GH',300:'GR',320:'GT',336:'VA',340:'HN',344:'HK',348:'HU',352:'IS',356:'IN',360:'ID',368:'IQ',372:'IE',376:'IL',380:'IT',383:'XK',384:'CI',392:'JP',398:'KZ',400:'JO',404:'KE',410:'KR',414:'KW',417:'KG',422:'LB',426:'LS',428:'LV',430:'LR',438:'LI',440:'LT',442:'LU',446:'MO',450:'MG',454:'MW',458:'MY',462:'MV',466:'ML',470:'MT',480:'MU',484:'MX',492:'MC',496:'MN',498:'MD',499:'ME',504:'MA',508:'MZ',512:'OM',516:'NA',520:'NR',528:'NL',548:'VU',554:'NZ',558:'NI',566:'NG',578:'NO',585:'PW',586:'PK',591:'PA',598:'PG',600:'PY',604:'PE',608:'PH',616:'PL',620:'PT',634:'QA',642:'RO',643:'RU',646:'RW',674:'SM',682:'SA',686:'SN',688:'RS',690:'SC',702:'SG',703:'SK',704:'VN',705:'SI',710:'ZA',716:'ZW',724:'ES',740:'SR',748:'SZ',752:'SE',756:'CH',762:'TJ',764:'TH',776:'TO',780:'TT',784:'AE',788:'TN',792:'TR',800:'UG',804:'UA',807:'MK',818:'EG',826:'GB',834:'TZ',840:'US',858:'UY',860:'UZ',882:'WS',894:'ZM'};
  var DN = null;
  try {
    var lang = (document.documentElement.getAttribute('lang') || 'cs').split('-')[0];
    if (window.Intl && Intl.DisplayNames) DN = new Intl.DisplayNames([lang], { type: 'region' });
  } catch (e) { DN = null; }
  function nazev(cesky, id) {
    if (!DN || !A2[id]) return cesky;
    try { return DN.of(A2[id]) || cesky; } catch (e) { return cesky; }
  }

  var ALL = [], BY_ID = {};
  function add(list, tier) {
    list.forEach(function (p) {
      var lokalni = nazev(p[0], p[1]);
      var it = { name: lokalni, id: p[1], tier: tier,
                 key: norm(lokalni) + ' ' + norm(p[0]) + ' ' + norm(ALIAS[p[0]] || '') };
      ALL.push(it); BY_ID[p[1]] = it;
    });
  }
  add(FULL, 'full'); add(DATA, 'data'); add(NONE, 'none');

  var input, out, svg, tip, current = null, feats = null, paths = null, view = 'world';

  /* Výchozí je svět (dává rozsah nabídky), Evropa je na přepnutí pro detail —
     ve světovém měřítku je Česko i Chorvatsko třípixelový střípek. */
  var EU_BOX = { type: 'MultiPoint', coordinates: [[-13, 27], [45, 27], [45, 71], [-13, 71]] };

  function card(item) {
    var t = TIERS[item.tier];
    var svc = item.tier === 'none' ? null
      : [[tr('svc_poloha', 'Poloha dítěte'), true], [tr('svc_zpravy', 'Zprávy a fotky'), true], [tr('svc_volani', 'Volání'), t.calls]];
    return '<div class="kl-zres kl-zres--' + item.tier + '">' +
      '<div class="kl-zres__head"><b class="kl-zres__name">' + item.name + '</b>' +
      '<span class="kl-zres__tag">' + t.label + '</span></div>' +
      '<p class="kl-zres__note">' + t.note + '</p>' +
      (svc ? '<ul class="kl-zres__svc">' + svc.map(function (s) {
        return '<li class="' + (s[1] ? 'is-yes' : 'is-no') + '"><svg aria-hidden="true"><use href="#i-' +
          (s[1] ? 'check' : 'x') + '"/></svg>' + s[0] + '</li>';
      }).join('') + '</ul>' : '') + '</div>';
  }

  function highlight(id) {
    current = id;
    if (!svg) return;
    svg.selectAll('path.kl-c').classed('is-on', function (d) { return String(d.id) === String(id); });
  }

  function show(item) {
    out.hidden = false;
    out.innerHTML = card(item);
    highlight(item.id);
  }

  function render(q) {
    var n = norm(q);
    if (!n) { out.hidden = true; out.innerHTML = ''; highlight(null); return; }
    var hits = ALL.filter(function (c) { return c.key.indexOf(n) > -1; });
    hits.sort(function (a, b) { return a.key.indexOf(n) - b.key.indexOf(n); });
    if (!hits.length) {
      out.hidden = false; highlight(null);
      out.innerHTML = '<div class="kl-zres kl-zres--miss"><b class="kl-zres__name">' +
        tr('miss_title', 'Tuhle zemi v seznamu nemáme') + '</b>' +
        '<p class="kl-zres__note">' + tr('miss_note', 'Napište nám na podporu a dostupnost pro konkrétní zemi ověříme.') + '</p></div>';
      return;
    }
    out.hidden = false;
    out.innerHTML = hits.slice(0, 3).map(card).join('');
    highlight(hits[0].id);
  }

  var W = 960, VIEW_H = { eu: 400, world: 330 };

  function syncMapAspect() {
    if (!HOST) return;
    HOST.style.aspectRatio = W + ' / ' + VIEW_H[view];
  }

  function projection() {
    var H = VIEW_H[view];
    if (view === 'eu') return d3.geoMercator().fitExtent([[8, 8], [W - 8, H - 8]], EU_BOX);
    return d3.geoNaturalEarth1().fitExtent([[6, 6], [W - 6, H - 6]], { type: 'FeatureCollection', features: feats });
  }

  /* animate=false při prvním vykreslení: transition by nechala v DOM staré
     „d“ a první snímek (i export) by ukázal jiný výřez, než jaký je zvolený. */
  function applyProjection(animate) {
    if (!paths) return;
    svg.attr('viewBox', '0 0 ' + W + ' ' + VIEW_H[view]);
    syncMapAspect();
    var p = d3.geoPath(projection());
    if (animate) paths.transition().duration(360).attr('d', p);
    else paths.attr('d', p);
  }

  function setView(v, animate) {
    view = v;
    document.querySelectorAll('[data-view]').forEach(function (b) {
      var on = b.dataset.view === v;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    applyProjection(animate !== false);
  }

  function drawMap() {
    var host = HOST;
    if (!host || typeof d3 === 'undefined' || typeof topojson === 'undefined') { if (host) host.classList.add('is-failed'); return; }
    syncMapAspect();
    svg = d3.select(host).append('svg')
      .attr('viewBox', '0 0 ' + W + ' ' + VIEW_H[view])
      .attr('role', 'img')
      .attr('aria-label', tr('map_aria', 'Mapa s vyznačenou dostupností hodinek KLOKI Moon podle zemí'));

    tip = d3.select(host).append('div').attr('class', 'kl-zmap__tip').style('opacity', 0);

    /* ZÁPLATA THEME: geometrie se bere z theme assetu, ne z cizí CDN.
       .js soubor neumí Liquid, takže URL přijde z data atributu, který
       vykreslí sekce (vzor: assets/bts.js). Fallback na původní CDN zůstává
       pro případ, že by atribut chyběl. */
    var geoUrl = host.getAttribute('data-kl-geo')
      || 'https://cdn.jsdelivr.net/npm/world-atlas@2.0.2/countries-110m.json';
    d3.json(geoUrl).then(function (topo) {
      feats = topojson.feature(topo, topo.objects.countries).features
        .filter(function (f) { return String(f.id) !== '010'; });          /* Antarktida ubírá výšku */

      paths = svg.selectAll('path').data(feats).join('path')
        .attr('class', 'kl-c')
        .attr('fill', function (d) { var it = BY_ID[Number(d.id)]; return it ? TIERS[it.tier].fill : NEUTRAL; })
        .style('cursor', function (d) { return BY_ID[Number(d.id)] ? 'pointer' : 'default'; })
        .on('mousemove', function (ev, d) {
          var it = BY_ID[Number(d.id)];
          var label = it ? it.name + ' — ' + TIERS[it.tier].label : (d.properties && d.properties.name) || '';
          if (!label) return;
          var r = host.getBoundingClientRect();
          tip.style('opacity', 1).html(label)
            .style('left', (ev.clientX - r.left) + 'px').style('top', (ev.clientY - r.top) + 'px');
        })
        .on('mouseleave', function () { tip.style('opacity', 0); })
        .on('click', function (ev, d) {
          var it = BY_ID[Number(d.id)];
          if (!it) return;
          input.value = it.name; show(it);
        });

      setView(view, false);
      if (current) highlight(current);
    }).catch(function () { host.classList.add('is-failed'); });
  }

  function init() {
    input = document.getElementById('kl-zone-q');
    out = document.getElementById('kl-zone-out');
    if (!input || !out) return;
    input.addEventListener('input', function () { render(input.value); });
    document.querySelectorAll('[data-zone]').forEach(function (b) {
      b.addEventListener('click', function () { input.value = b.dataset.zone; render(b.dataset.zone); });
    });
    document.querySelectorAll('[data-view]').forEach(function (b) {
      b.addEventListener('click', function () { setView(b.dataset.view, true); });
    });
    drawMap();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
